import type { FpMessagePart } from "../../../../../schemas/codegen";

interface SystemMessageProps {
  part: Extract<FpMessagePart, { type: "tool-call" }>;
}

export function SystemMessage({ part }: SystemMessageProps) {
  // Extract the system message content from the args
  const systemContent =
    (part.args?.content as string) ||
    (part.args?.message as string) ||
    "System message";

  return <div className="text-danger text-sm">{systemContent}</div>;
}
